/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
import {
  post as postAxios,
  put as putAxios,
  get as getAxios,
} from "../apiHandler";

const endPoint = process.env.REACT_APP_API_BASE_URL;
const PAGE_SIZE = 10;

const post = (url, { accessToken, data, params }) =>
  postAxios(url, { accessToken, data, endPoint, params });
const put = (url, { accessToken, data, params }) =>
  putAxios(url, { accessToken, data, endPoint, params });
const get = (url, { data, accessToken }) =>
  getAxios(url, { data, accessToken, endPoint });

export default class SpecialGroup {
  static divisionGraduation(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post(`/api/division_graduation`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    SpecialGroup.divisionGraduation.cancel = request.cancel;
    return request;
  }

  static induction(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post(`/api/specialGroups/induction`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    SpecialGroup.induction.cancel = request.cancel;
    return request;
  }

  static graduation(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = put(`/api/specialGroups/graduation`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    SpecialGroup.graduation.cancel = request.cancel;
    return request;
  }

  static getAllSpecialGroups() {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get("/api/masters/specialGroups", {
      accessToken: accessTokenFromLocal,
    });

    SpecialGroup.getAllSpecialGroups.cancel = request.cancel;
    return request;
  }

  static getDivisionSpecialGroup({ data, divisionId }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/specialGroups/division/${divisionId}`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    SpecialGroup.getDivisionSpecialGroup.cancel = request.cancel;
    return request;
  }
}
